module.exports = __webpack_public_path__ + "static/media/CLC_cover_06.87d05d2e.jpg";